var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.837 8.54348C11.837 9.94903 10.699 11.087 9.29348 11.087C7.88793 11.087 6.75 9.94678 6.75 8.54348C6.75 7.14018 7.88793 6 9.29348 6C10.699 6 11.837 7.13793 11.837 8.54348Z",
    stroke: "#626262",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9198 8.82609C14.9198 8.36371 14.8594 7.91982 14.7596 7.48915L16.6196 6.1258L15.2272 3.70029L13.1229 4.6409C12.4766 4.02792 11.6937 3.56026 10.8189 3.29868L10.5772 1H7.7924L7.55071 3.29868C6.67587 3.56026 5.89299 4.02528 5.24671 4.6409L3.14238 3.70029L1.75 6.1258L3.61001 7.48915C3.50755 7.91982 3.44975 8.36635 3.44975 8.82609C3.44975 9.28582 3.51018 9.73235 3.61001 10.163L1.75 11.5264L3.14238 13.9519L5.24671 13.0113C5.89299 13.6243 6.67587 14.0919 7.55071 14.3535L7.7924 16.6522H10.5772L10.8189 14.3535C11.6937 14.0919 12.4766 13.6269 13.1229 13.0113L15.2272 13.9519L16.6196 11.5264L14.7596 10.163C14.862 9.73235 14.9198 9.28582 14.9198 8.82609Z",
    stroke: "#626262",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSetting);
export default __webpack_public_path__ + "static/media/icon_setting.96eab1b57255ec620f03658bf7c05e48.svg";
export { ForwardRef as ReactComponent };